import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../features/auth/authSlice";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
import { config } from "../utils/axiosconfig";
import { resolveMediaUrl } from "../utils/mediaUrl";

const ViewProfile = () => {
  const dispatch = useDispatch();
  const { profile, user } = useSelector((state) => state.auth);

  const [isEditing, setIsEditing] = useState(false); // Toggle between view and edit modes
  const [formData, setFormData] = useState({
    name: "",
    image: "",
    address: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    if (user?.data?._id) {
      dispatch(getProfile(user.data._id)); // Fetch admin profile data
    }
  }, [dispatch, user]);

  useEffect(() => {
    if (profile) {
      setFormData({
        name: profile.name || "",
        image: profile.image || "",
        address: profile.address || "",
        email: profile.email || "",
        phone: profile.phone || "",
      });
    }
  }, [profile]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedData = new FormData();
      updatedData.append("name", formData.name);
      updatedData.append("image", formData.image);
      updatedData.append("address", formData.address);
      updatedData.append("email", formData.email);
      updatedData.append("phone", formData.phone);

      const response = await axios.put(
        `${base_url}admin/profile/${user.data._id}`,
        updatedData,
        config
      );

      console.log("Profile updated successfully:", response.data);
      setIsEditing(false); // Switch back to view mode
      dispatch(getProfile(user.data._id)); // Refresh profile data
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  if (!profile) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center">
        <h1>Admin Profile</h1>
        <button
          className="btn btn-primary"
          onClick={() => setIsEditing(!isEditing)}
        >
          {isEditing ? "Cancel" : "Edit"}
        </button>
      </div>
      <div className="card p-4">
        {isEditing ? (
          // <form>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Name
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="image" className="form-label">
                Profile Image
              </label>
              <input
                type="file"
                className="form-control"
                id="image"
                name="image"
                onChange={handleImageChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="address" className="form-label">
                Address
              </label>
              <input
                type="text"
                className="form-control"
                id="address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="phone" className="form-label">
                Phone
              </label>
              <input
                type="text"
                className="form-control"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
              />
            </div>
            <button type="submit" className="btn btn-success">
              Save Changes
            </button>
          </form>
        ) : (
          <div>
            <div className="d-flex align-items-center">
              <img
                src={profile.image ? resolveMediaUrl(profile.image) : "default-profile.png"}
                alt="Profile"
                className="rounded-circle"
                width="100"
                height="100"
              />
              <div className="ms-4">
                <h3>{profile.name || "Admin Name"}</h3>
                <p>{profile.email || "admin@example.com"}</p>
              </div>
            </div>
            <hr />
            <div>
              <h5>Additional Information</h5>
              <p>
                <strong>Address:</strong> {profile.address || "N/A"}
              </p>
              <p>
                <strong>Phone:</strong> {profile.phone || "N/A"}
              </p>
              <p>
                <strong>Role:</strong> {profile.role || "Admin"}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewProfile;